export default "__VITE_ASSET__DtAq7BSw__"